import { useContext } from 'react';

import type { ToastDispatcher } from '../types';
import { ToastContext } from './ToastContext';

/**
 * Return a function to open a toast alert. The alert disappears after a
 * timeout. Requires the {@link ToastProvider} set up in the app.
 *
 * @example
 *
 * ```tsx
 * function ToastExample() {
 *  const openToast = useToast();
 *  const toast = {
 *    sentiment: ToastSentiment.Neutral,
 *    message: 'Your order has been submitted.',
 *  };
 *  return (
 *    <div style={{ paddingTop: 60 }}>
 *      <button onClick={() => openToast(toast)}>Open Toast</button>
 *    </div>
 *  );
 * }
 * ```
 */
export function useToast(): ToastDispatcher {
  const { openToast } = useContext(ToastContext);
  return openToast;
}
